const ERRORS = {
  404: 'Page Not Found!',
  DEFAULT: 'Oops! Something went wrong.',
};

export const errorText = (code) => ERRORS[code] || ERRORS.DEFAULT;
